export const businessInfo = {
  name: 'Vemmac Kitchen',
  addressLines: ['Fmc Line Shop 1', 'Asaba, Delta State 320001', 'Nigeria'],
  phoneDisplay: '+234 806 051 2820',
  phoneHref: 'tel:+2348060512820',
  email: 'vemmackitchenasaba@gmail.com',
  emailHref: 'mailto:vemmackitchenasaba@gmail.com',
};

export const socialLinks = [
  {
    label: 'Instagram',
    href: process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/vemmackitchen',
  },
  {
    label: 'Facebook',
    href: process.env.REACT_APP_FACEBOOK_URL || 'https://www.facebook.com/vemmackitchen',
  },
  {
    label: 'TikTok',
    href: process.env.REACT_APP_TIKTOK_URL || 'https://www.tiktok.com/@vemmackitchen',
  },
];
